import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { WhalesCompanySelect } from 'containers/dashboard/benchmarkReport/whalesSection/components/WhalesCompanySelect'
import { WhalesChartSimple } from 'containers/dashboard/benchmarkReport/whalesSection/components/WhalesChartSimple'
import WhalesList from 'containers/dashboard/benchmarkReport/whalesSection/WhalesList'
import { Whale } from 'store/reporting/benchmark/types'
import WhaleElement from 'containers/dashboard/benchmarkReport/whalesSection/components/WhaleElement'
import { calculateBenchmarkChartData } from 'containers/dashboard/benchmarkReport/whalesSection/calculateBenchmarkChartData'
import { WhalesChart } from 'containers/dashboard/benchmarkReport/whalesSection/WhalesChart'
import { WhalesStartYearSelect } from 'containers/dashboard/benchmarkReport/whalesSection/components/WhalesStartYearSelect'

type Props = {
  targetName: string
  benchmarkWhales: Whale[]
  showExtended?: boolean
}

export default function WhalesSection({ targetName, benchmarkWhales, showExtended }: Props) {
  const targetWhale = benchmarkWhales.find(w => w.dn === targetName) ?? benchmarkWhales[0]
  const targetNameFound = benchmarkWhales.some(w => w.dn === targetName)
  const [selectedDn, setSelectedDn] = useState(targetWhale.dn)
  const [startYear, setStartYear] = useState<number | null>(null)

  const yearOptions = Array.from(
    new Set(benchmarkWhales.flatMap(w => Object.keys(w.cbq).map(q => Number(q.split('Q')[0])))),
  ).sort((a, b) => a - b)
  const selectedWhale = benchmarkWhales.find(w => w.dn === selectedDn) ?? targetWhale
  const chartData = calculateBenchmarkChartData(selectedWhale, benchmarkWhales, startYear)
  return (
    <Box mt={2}>
      {!targetNameFound && (
        <Typography color="warning.main" mb={4}>
          Target "{targetName}" was not found in the benchmark results. Showing the first available company instead.
        </Typography>
      )}
      <Box mt={2} mb={2} display={'flex'}>
        <WhalesCompanySelect targetWhale={targetWhale} whales={benchmarkWhales} value={selectedDn} onChange={setSelectedDn} />
        <Box mx={1}></Box>
        <WhalesStartYearSelect years={yearOptions} value={startYear} onChange={setStartYear} />
      </Box>
      <WhalesChart
        name={selectedWhale.dn}
        quarters={chartData.quarters}
        target={chartData.targetSeries}
        avg={chartData.avgSeries}
        upper={chartData.upper}
        lower={chartData.lower}
      />
      {showExtended && (
        <>
          <WhalesChartSimple name={selectedWhale.dn} cbq={selectedWhale.cbq} />
          <Box mb={8} sx={{ '& .MuiTypography-root': { fontSize: '0.7rem' } }}>
            <WhaleElement whale={selectedWhale} />
          </Box>
          <WhalesList whales={benchmarkWhales} limit={10} />
        </>
      )}
    </Box>
  )
}
